<template>
    <div class="issued-task">
        <form action="javascript:void(0)">
            <van-search
                    background="#fff"
                    v-model="keyword"
                    placeholder="请输入搜索关键词"
                    :clearable="false"
            />
        </form>

        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
                v-if="!emptyShow"
        >
            <IssuedTaskItem v-for="(item,index) in parsedList" :key="index" :item="item"/>
        </van-list>
        <div class="empty-container" v-else>
          <Error type="empty"/>
        </div>
    </div>
</template>

<script>
    import {List, Cell, Search} from 'vant'
    import {queryIssuedTaskList} from "@/api/my-items"
    import IssuedTaskItem from "@/components/IssuedTask/IssuedTaskItem"

    export default {
        name: 'IssuedTask',
        components: {
            [List.name]: List,
            [Cell.name]: Cell,
            [Search.name]: Search,
            IssuedTaskItem,
        },
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                error: false,
                pageIndex: 0,
                keyword: '',
                emptyShow: false //空空如也是否显示
            }
        },
        computed: {
            parsedList() {
                return this.list.filter(item => item.taskName.includes(this.keyword))
            },
        },
        created() {
        },
        methods: {
            onLoad() {
                this.loading = true;
                queryIssuedTaskList(this.pageIndex)
                    .then(resp => {
                        this.list = this.list.concat(resp.data)
                        if (this.list.length >= resp.total) this.finished = true
                        if (!resp.total) {
                          this.emptyShow = true;
                        } else {
                          this.emptyShow = false;
                        }
                        this.pageIndex++
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                        this.error = true
                    })
                    .finally(() => {
                      this.loading = false;
                    })
            },

        }
    }
</script>

<style scoped lang="scss">
    .van-search {
      padding: 0;
      margin-bottom: 10px;
      border-radius: 6px;
      .van-search__content{
        background-color: inherit;
      }
    }

    .issued-task {
      padding: 0 15px 10px;
    }
</style>
